export const GroupsActionType = Object.freeze({
    SET_EDIT_GROUP: 'Authorization:: Edit group data',
    SET_EXISTING_PERMISSIONS: 'Groups:: Set existing permissions',
    SET_EXISTING_USERS: 'Groups:: Set existing users',
    SET_GROUPS: 'Groups:: Set all groups data',
    SET_TAB: 'GroupPanel:: Set Tab',
    SET_BREAK_DOWN: 'GroupPanel:: Set breakdown',
    CLOSE_EDIT_DIALOG: 'Groups:: Close edit group dialog box',
    OPEN_EDIT_DIALOG: 'Groups:: Open edit group dialog box',
    CLOSE_CREATE_DIALOG: 'Groups:: Close create group dialog box',
    OPEN_CREATE_DIALOG: 'Groups:: Open create group dialog box',
    SET_INVITE_TYPE: 'Groups:: On set type of the invite dialog',
    SET_INVITE_LINK: 'Groups:: Set Invite link',
    SET_ORDER_BY: 'Group Table:: Set Order by field',
    SET_PAGING_OPT: 'Group Table:: Set Pagination options',
    SET_FILTER: 'Group Table:: Set Filter',
    SET_SEARCH_TEXT: 'Group Table :: Set Search Text',
    SET_PAGE_OFFSET: 'Group Table :: Set Offset of the group table query',
    SET_CONFIRMATION_DIALOG: 'Group Table:: Delete confirmation Dialog',
    SET_CREATE_GROUP: 'Create Group Dialog:: Create group data set',
})

export const GROUP_PROP = Object.freeze({
    ID: 'id',
    NAME: 'name',
    PERMISSIONS: 'permissions',
    USERS: 'users',
    CREATE_DATE: 'create_date',
    UPDATE_DATE: 'update_date',
})

export const UILabels = {
    [GROUP_PROP.NAME]: 'Name',
    [GROUP_PROP.PERMISSIONS]: 'Permissions',
    [GROUP_PROP.USERS]: 'Users',
    [GROUP_PROP.CREATE_DATE]: 'Created On',
    [GROUP_PROP.UPDATE_DATE]: 'Updated On',
}

export const GROUP_COLUMNS_ENHANCED = Object.freeze([
    {
        id: 'drop_word',
        numeric: false,
        disablePadding: false,
        disableSort: true,
    },
    {
        id: GROUP_PROP.NAME,
        label: UILabels[GROUP_PROP.NAME],
        numeric: false,
        disablePadding: false,
    },
    {
        id: GROUP_PROP.PERMISSIONS,
        label: UILabels[GROUP_PROP.PERMISSIONS],
        numeric: false,
        disablePadding: false,
        disableSort: true,
    },
    {
        id: GROUP_PROP.CREATE_DATE,
        label: UILabels[GROUP_PROP.CREATE_DATE],
        numeric: false,
        disablePadding: false,
        disableSort: true,
    },
    {
        id: GROUP_PROP.UPDATE_DATE,
        label: UILabels[GROUP_PROP.UPDATE_DATE],
        numeric: false,
        disablePadding: false,
        disableSort: true,
    },
])

export const ITEM_HEIGHT = 48
export const ITEM_PADDING_TOP = 8
export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
}
